export const checkAccountStatusResources_actionType = {
    CHECK_ACCOUNT_STATUS: 'CHECK_ACCOUNT_STATUS',
    CHECK_ACCOUNT_STATUS_SUCCESS: 'CHECK_ACCOUNT_STATUS_SUCCESS',
    CHECK_ACCOUNT_STATUS_ERROR: 'CHECK_ACCOUNT_STATUS_ERROR',
    RESET_CHECK_ACCOUNT_STATUS: 'RESET_CHECK_ACCOUNT_STATUS'
};